// src/components/projects/ProjectDetailsModal.js - OPRAVENÁ VERZE
import React, { useEffect, useCallback } from 'react';
import { X } from 'lucide-react';
import ProjectCard from './ProjectCard';

const ProjectDetailsModal = ({ 
  isOpen, 
  onClose, 
  project,
  onEdit,
  onAddWorkLog,
  onEditWorkLog,
  onDeleteWorkLog,
  onAddFile,
  userRole,
  currentUserId,
  onProjectUpdate
}) => {
  // ✅ STABILNÍ onProjectUpdate callback - previne zacyklení
  const stableOnProjectUpdate = useCallback((updatedProject) => {
    if (onProjectUpdate && updatedProject) {
      // Pouze aktualizuj pokud se projekt skutečně změnil
      onProjectUpdate(updatedProject);
    }
  }, [onProjectUpdate]);

  // Custom handler for edit to ensure button events get handled correctly
  const handleEdit = (projectToEdit) => {
    // Do NOT close the details modal when opening the edit modal
    // Just call the original handler
    onEdit(projectToEdit);
  };

  // Same for other handlers - just pass them through without closing the modal
  const handleAddWorkLog = (projectId) => {
    onAddWorkLog(projectId);
  };
  
  const handleEditWorkLog = (workLog, projectId) => {
    onEditWorkLog(workLog, projectId);
  };
  
  const handleAddFile = (projectId) => {
    onAddFile(projectId);
  };

  if (!isOpen || !project) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-40">
      <div className="relative top-20 mx-auto p-5 border w-full max-w-3xl shadow-lg rounded-md bg-white">
        <div className="flex justify-end mb-2">
          <button 
            onClick={onClose} 
            className="text-gray-400 hover:text-gray-500"
          >
            <X className="h-6 w-6" />
          </button>
        </div>
        
        <div className="overflow-y-auto max-h-[calc(100vh-160px)]">
          <ProjectCard
            project={project}
            onEdit={handleEdit}
            onAddWorkLog={handleAddWorkLog}
            onEditWorkLog={handleEditWorkLog}
            onDeleteWorkLog={onDeleteWorkLog}
            onAddFile={handleAddFile}
            userRole={userRole}
            currentUserId={currentUserId}
            onProjectUpdate={stableOnProjectUpdate}
            isInModal={true}
            forceLoadFiles={true}
          />
        </div>
      </div>
    </div>
  );
};

export default ProjectDetailsModal;